import { useCallback } from "react";
import { get_product_by_id } from "@/api/v4/finance";

export default (callback, deps) => {
  const cb = useCallback(
    (productObj) => {
      get_product_by_id({
        params: { productId: productObj.id },
      })
        .then((product) => {
          callback && callback({ data: product });
        })
        .catch((e) => {
          callback && callback({ err: e.message, data: e });
        });
    },
    [callback, deps]
  );

  return cb;
};
